import React from 'react';
import { Navigate } from 'react-router-dom';

// Convex Auth's password reset (see ResendOTPPasswordReset.ts) is code-based,
// not magic-link-based -- there's no separate URL a reset email points at.
// The whole request-code -> enter-code-and-new-password flow now lives on
// ForgotPasswordPage; this route only exists so old bookmarks/links don't 404.
export default function ResetPasswordPage() {
  return <Navigate to="/forgot-password" replace />;
}
